module.exports = __webpack_public_path__ + "de630cda33fbffffa973d492eeacc094.png";